import { Input, Select, Form, Tooltip, DatePicker, Empty } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import ComponentsBreadcrumb from "../../../layout/componentsBreadcrumb";
import {  getTransactions, getWallets,getTransactionGridDetils } from './api'
import moment from "moment/moment";
import { connect } from "react-redux";
import { utils, writeFile } from 'xlsx';
import { debouncedGrid } from "./service";
import { isErrorDispaly } from "../../../shared/validationsAndExceptions/apiExceptions";
import AppRow from "../../../shared/appRow";
import AppAlert from "../../../shared/appAlert";
import AppCol from "../../../shared/appCol";
import AppTitle from "../../../shared/appTitle";
import Loader from "../../../shared/loader";
const { RangePicker } = DatePicker;
const { Option } = Select;

const ViewTransactionComponent = (props) => {
  const [loader, setLoader] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null);
  const [transactionType, setTransactionType] = useState('All');
  const [transactionLu, setTransactionLu] = useState([])
  const [wallets, setWallets] = useState('All');
  const [walletsLu, setWalletsLu] = useState([]);
  const [searchGridDataFilter, setSearchGridDataFilter] = useState([]);
  const [selectedDates, setSelectedDates] = useState(null)
  const [searchQuery, setSearchQuery] = useState(null);
  const [totalGridDataCount, setTotalGridDataCount] = useState(50)
  const history = useHistory()
  const [pageNo, setPageNo] = useState(1);
  let pageSize = 20;

  const [form] = Form.useForm();
  const { Search } = Input;
  const breadCrumbList = [
    { id: '1', bname: 'Payment Artha',url : '/dashboard' },
    { id: '2', bname: 'Transactions' }
  ];
  const btnColourList = {
    Success: "table-text td-success",
    Submitted: "table-text td-success",
    Approved: "table-text td-success",
    Cancelled: "table-text text-red",
    Rejected: "table-text text-red",
    Pending: "table-text text-blue",
  };
  const iconColourList = {
    Deposit: "icon md deposit",
    Withdraw: "icon md withdraw",
  };

  useEffect(() => {
    form.setFieldsValue('transactionType', "All");
    form.setFieldsValue('wallets', "All");
    getTransactionLU();
    getWalletsLu(props?.userConfig?.id);
  }, []);
  useEffect(()=>{
    if(wallets){
      getTransactionGrid(0, props?.userConfig?.id, searchQuery || null,transactionType,wallets,selectedDates,pageNo);
    }
  },[wallets,transactionType,selectedDates]);

  const getWalletsLu = async (customerId) => {
    const response = await getWallets(customerId);
    if (response.ok) {
      setLoader(false)
      setWalletsLu(response.data);
      setErrorMessage(null)
    } else {
      setLoader(false)
      setErrorMessage(isErrorDispaly(response.data));
    }
  }
  const getTransactionLU = async () => {
    const response = await getTransactions();
    if (response.ok) {
      setLoader(false)
      setTransactionLu(response.data.Coins);
      setErrorMessage(null)
    } else {
      setLoader(false)
      setErrorMessage(isErrorDispaly(response.data));
    }
  }
  const fetchMoreData = () => {
    if (searchGridDataFilter.length < totalGridDataCount) {
      getTransactionGrid(0, props.userConfig.id, searchQuery || null,transactionType,wallets,selectedDates,pageNo);
    }
  };
  const gridCallback = (data, error) => {
    if (data) {
      setPageNo(prevPageNo => prevPageNo + 0)
      setSearchGridDataFilter(prevData => [...prevData, ...data.data]);
      setLoader(false)
      setTotalGridDataCount(data.total)
      setErrorMessage(null);
      return
    }
    setErrorMessage(error)
    setLoader(false)
  }
  const getTransactionGrid = async (timeout, id, search,selectedTransactionType,selectedWallets,setSelectedDatesData, defaultpageNo) => {
    setLoader(true);
    debouncedGrid(timeout, id, search, gridCallback, defaultpageNo, pageSize,selectedTransactionType,selectedWallets,setSelectedDatesData)
  };

  const handleSearchGrid = (e) => {
    const searchList = e.target.value?.replace(/^\s+/, '');
    setSearchQuery(searchList);
    if (searchList.length > 2) {
      setSearchGridDataFilter([])
      setPageNo(1)
      setLoader(true)
      setTotalGridDataCount(50);
        getTransactionGrid(1000, props?.userConfig?.id, searchQuery, transactionType, wallets, selectedDates, 1);
    }
    if (searchList === "") {
      setSearchGridDataFilter([]);
      getTransactionGrid(1000, props?.userConfig?.id, null, transactionType, wallets, selectedDates, 1);
    }
  };
  const handleExportToExcel = async () => {
    let _fromDate = selectedDates?.length >0 ? selectedDates[0] : '';
    let _toDate = selectedDates?.length > 0 ?  selectedDates[1] : '';
    const response = await getTransactionGridDetils(props?.userConfig?.id,transactionType, wallets,searchQuery || null, _fromDate,_toDate,pageNo,pageSize,);
    if (response.ok) {
      const dataToExport = response.data.data;
      const excelData = dataToExport.map((item) => {
        return {
          "Transaction ID": item.trasactionOrderId || "-",
          "Date": moment.utc(item.transactionDate).local().format("DD/MM/YYYY hh:mm:ss A") || "-",
          "Merchant Account":item.merchantName || "-",
          "Transaction Type": item.transactionType || "-",
          "Value": item.value,
          "Wallet": item.wallet || "-",
          "Network":item.network || "-",
          "Status": item.status || "-",
        };
      });
      const worksheet = utils.json_to_sheet(excelData);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, 'Sheet 1');

      const columnWidths = [{ wch: 22 }, { wch: 22 }, { wch: 22 }, { wch: 22 }, { wch: 15 }, { wch: 15 }, { wch: 25 }];
      worksheet['!cols'] = columnWidths;

      writeFile(workbook, 'Transaction Data.xlsx');

      setErrorMessage(null);
    } else {
      setErrorMessage(isErrorDispaly(response));
    }
  };
  const handleTransactions = (e) => {
    setSearchGridDataFilter([])
    setTransactionType(e);
  }
  const handleWallets = (e) => {
    setSearchGridDataFilter([])
    setWallets(e);
  }
  const handleOpen = (item) => {
    history.push(`/transactionDetails/${item?.id}/${item?.transactionType}`)
  }
  const handleDates = (dates, dateStrings) => {
    setSearchGridDataFilter([])
    setSelectedDates(dateStrings);
  };
  return (
    <>
    <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />
      <div className='d-flex align-start transactions-header filters-wrap'>

        <Form
          form={form}
          initialValues={{transactionType:'All',wallets:'All'}}
          className="d-flex payment-filters align-center gap-16"

        >
          <Form.Item
            name="transactionType"
            className="mb-0 payee-field sm-mb-10"
            colon={false}
          >
            <Select

              onChange={(e) => handleTransactions(e)}
              placeholder="Select Transaction Type"
              className="payee-input input-bordered"
              maxLength={30}
              defaultValue={'All'}
            >
              {transactionLu?.map((item, index) => (
                <Option key={index} value={item.name}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="wallets"
            className="mb-0 payee-field sm-mb-10"
            colon={false}
          >
            <Select
              onChange={(e) => handleWallets(e)}
              placeholder="Select Wallet"
              className="payee-input input-bordered"
              maxLength={30}
              defaultValue={'All'}
            >
              {walletsLu?.map((item, index) => (
                <Option key={index} value={item.code}>
                  {item.code}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <RangePicker className="payee-input input-bordered text-white sm-mb-10" onChange={handleDates} />
        </Form>
        <div className="transaction-mobile-actions">
        <div className="d-flex align-center transactions-search">

<div className="coin-search mb-0">
  <Search value={searchQuery} placeholder='Search Transaction' suffix={<span className="icon md search c-pointer" />}
    onChange={handleSearchGrid} size="middle" bordered={false} className="coin-search-input " />
</div>
<div className="text-right export-pdf secureDropdown">
  <Tooltip placement="top" title={"Export Excel"}>
    <button className="c-pointer btn-style"
      onClick={() => {
        handleExportToExcel()
      }}
    >
      <span className="icon excel"></span>
      <span
        className="icon xl mr-0 excelexport"
      ></span></button>
  </Tooltip>
</div>
</div>
        </div>

      </div>
      <AppRow>
        {errorMessage !== undefined && errorMessage !== null && errorMessage !== "" && (
          <div className="alert-flex" style={{ width: "100%" }}>
            <AppAlert
              className="w-100 "
              type="warning"
              description={errorMessage}
              showIcon
            />
            <button className="icon sm alert-close" onClick={() => setErrorMessage(null)}></button>
          </div>
        )}
        <AppCol xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <div className="layout-bg left-panel pannel-bg mt-14 sm-m-0 transactions-scroll all-transactions">
            <InfiniteScroll
              className="table-scroll"
              dataLength={searchGridDataFilter?.length}
              next={fetchMoreData}
              hasMore={searchGridDataFilter?.length < totalGridDataCount}
              endMessage={searchGridDataFilter?.length > 0 &&
                <div className="text-center">
                  {searchGridDataFilter?.length !== 0 && <span className="text-white">Yay! You have seen it all </span>}
                </div>}
            >
              <table style={{width:"100%",minWidth:1250}} className="alltransactions-table">
                {searchGridDataFilter && <>
                  {searchGridDataFilter?.map(item =>
                      <tr className="custom-table card" key={item.id}>
                        <td className="id-width" width={200}>
                          <label htmlFor className="table-label">Transaction ID</label><AppTitle level={4} className="table-text c-pointertransaction-id-text text-link c-pointer" onClick={() => handleOpen(item)}>{item?.txId}</AppTitle>
                          </td>
                        <td className="" width={230}>
                          {/* <div>
                            <span className={iconColourList[item.doctype]}></span>
                            </div> */}
                            <div className=""><label htmlFor className="table-label">
                          Date</label><AppTitle level={4} className="table-text" >
                              {item?.transactionDate ? <>{moment.utc(item?.transactionDate).local().format("DD/MM/YYYY hh:mm:ss A")}</> : item?.transactionDate}</AppTitle>
                              </div>
                              </td>
                              <td className="" width={220}><label htmlFor className="table-label">Merchant Account</label><AppTitle level={4} className="table-text">{item?.merchantName}</AppTitle></td>
                        <td className=""><label htmlFor className="table-label">Transaction Type</label><AppTitle level={4} className="table-text">{item?.transactionType}</AppTitle></td>
                        {/* <div className=""><label htmlFor className="table-label">Type</label><AppTitle level={4} className="table-text">{item?.type}</AppTitle></div> */}
                        <td className=" value-feild"><label htmlFor className="table-label">Value</label><AppTitle level={4} className="table-text">{item.value}
                        </AppTitle></td>
                        <td className=""><label htmlFor className="table-label">Wallet</label><AppTitle level={4} className="table-text">{item?.wallet}</AppTitle></td>
                        <td className=""><label htmlFor className="table-label">Network</label><AppTitle level={4} className="table-text">{item?.network}</AppTitle></td>
                        <td className=""><label htmlFor className="table-label">Status</label><AppTitle level={4}
                          className={item.status === "Approved" && "table-text td-success" || btnColourList[item.status]}>
                          {item?.status ? item?.status : "-"}
                        </AppTitle>
                        </td>
                        {/* <div className=""><label htmlFor className="table-label">Reason For Rejection</label><AppTitle level={4} className="table-text">{item?.reasonForRejection||"--"}</AppTitle></div> */}
                      </tr>
                  )}</>}
              </table>
              {searchGridDataFilter?.length === 0 && !loader && <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No Data"
              ></Empty>}
            </InfiniteScroll>
            <Loader spinning={loader} />
          </div>
        </AppCol >
      </AppRow >
    </>
  );
};
const connectStateToProps = ({ userConfig }) => {
  return {
    userConfig: userConfig.userProfileInfo
  }
}
export default connect(connectStateToProps)(ViewTransactionComponent);